import { useState, useContext, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";

import SuiButton from "components/SuiButton";
import Prompt from "components/UpStyled/Prompt";
import api from "services/api";
import { AccountContext } from "context/account";

const FollowButton2 = ({ user, size = "large", style = "w-full", ...rest }) => {
  const [dialogVisible, setDialogVisible] = useState(false);
  const [currentUser, setCurrentUser] = useState(user);
  const [isHovered, setIsHovered] = useState(false);
  const [followingList, setFollowingList] = useState([]);

  const account = useContext(AccountContext);

  const navigate = useNavigate();

  useEffect(() => {
    setCurrentUser(user);
  }, [user]);

  useEffect(() => {
    if (account.id && user?.id) retrieveFollowingList(1);
  }, [account.id, user]);

  const clickButton = async (new_follow_type) => {
    if (currentUser?.id) {
      if (!account?.id) {
        navigate("/login");
        return;
      }
      const { data } = await api.social.follow(currentUser.id, new_follow_type);
      setIsHovered(false);
      setCurrentUser({ ...currentUser, follow_type: new_follow_type });
    }
  };

  const retrieveFollowingList = async () => {
    try {
      const { data } = await api.social.followlist("following");
      console.log(data);
      setFollowingList(data?.list);
      const list = data?.list || [];
      const followingIndex = list.findIndex((x) => x.id == currentUser?.id);
      if (followingIndex > -1) {
        setCurrentUser({ ...currentUser, follow_type: 1 });
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div
      className="${style} flex"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {currentUser?.follow_type == 1 ? (
        <SuiButton
          key={currentUser.id + "_Follow_1_H"}
          size={size}
          circular
          color={isHovered ? "error" : "info"}
          variant={isHovered ? "outlined" : "gradient"}
          sx={{ width: "100%" }}
          onClick={(event) => {
            setDialogVisible(true);
          }}
          {...rest}
        >
          {isHovered ? "Unfollow" : "Following"}
        </SuiButton>
      ) : (
        <SuiButton
          key={currentUser.id + "_Follow_0"}
          size={size}
          circular
          color="info"
          variant="gradient"
          sx={{ width: "100%" }}
          onClick={(event) => clickButton(1)}
          {...rest}
        >
          Follow
        </SuiButton>
      )}
      {dialogVisible && (
        <Prompt
          heading="Unfollow"
          text={`Are you sure you want to unfollow ` + currentUser.name + `?`}
          visible={dialogVisible}
          okText="Unfollow"
          okColor="error"
          handleOk={() => {
            setDialogVisible(false);
            clickButton(0);
          }}
          handleClose={() => setDialogVisible(false)}
        />
      )}
    </div>
  );
};

export default FollowButton2;
